<template>
  <div class="container-fluid">
    <h1>rmCloud Configuration</h1>
    <requirement-types-view></requirement-types-view>
    <custom-attributes-view></custom-attributes-view>
    <div class="mt-5">
      <h4>Link Confluence Content</h4>
      <p v-if="$auth.user().installed_on_confluence">You have successfully connected your confluence instance.</p>
      <p v-else>If you'd like to link Confluence content to your requirements, please install <a href="#">rmCloud Connector</a> on your Confluence instance.</p>
    </div>
    <div class="mt-5">
      <b-form @submit="onSubmit">
        <h4>Other settings</h4>
        <h5>When a requirement is created or updated</h5>
        <div class="form-check">
          <label class="form-check-label">
            <input v-model="commentOnAssociatedIssues" type="checkbox" class="form-check-input">
            Add comment to associated Jira issues
          </label>
        </div>
        <h5>When a requirement is assigned</h5>
        <div class="form-check">
          <label class="form-check-label">
            <input v-model="sendEmailNotificationToAssignee" type="checkbox" class="form-check-input">
            Send email notification to assignee
          </label>
        </div>
        <div v-if="$auth.user().installed_on_confluence">
          <h5>Confluence space(s) to show when linking to requirements</h5>
          <p>Only pages from these spaces will show up when linking requirements to pages.</p>
          <p>Leave this blank if you want to show pages from all spaces.</p>
          <p>To get your space name, check the URL of one of your Confluence pages. It will be yoursite.atlassian.net/wiki/spaces/SPACENAME/...</p>
          <div class="form-group col-md-6">
            <input v-model="confluenceSpacesToFilter" type="text" class="form-control" placeholder="SPACE1,SPACE2">
            <small id="spacesHelpBlock" class="form-text text-muted">
              The space names should be comma separated e.g. SPACE1,SPACE2,SPACE3
            </small>
          </div>
        </div>
        <b-button type="submit" variant="primary">Save</b-button>
      </b-form>
    </div>
  </div>
</template>

<script>
import utilsMixin from '@/mixins/utils'
import RequirementTypesView from '@/components/configuration/RequirementTypesView'
import CustomAttributesView from './CustomAttributesView'
export default {
  components: {CustomAttributesView, RequirementTypesView},
  mixins: [utilsMixin],
  data () {
    return {
      commentOnAssociatedIssues: null,
      sendEmailNotificationToAssignee: null,
      confluenceSpacesToFilter: ''
    }
  },
  methods: {
    onSubmit (e) {
      e.preventDefault()
      this.patchUpdateCustomer()
    },
    patchUpdateCustomer () {
      this.$http.patch(
        '/api/customer/settings',
        {
          comment_on_associated_issues: this.commentOnAssociatedIssues,
          send_email_notification_to_assignee: this.sendEmailNotificationToAssignee,
          confluence_spaces_to_filter: this.confluenceSpacesToFilter
        }
      ).then(response => {
        this.$auth.user().comment_on_associated_issues = response.data.comment_on_associated_issues
        this.$auth.user().send_email_notification_to_assignee = response.data.send_email_notification_to_assignee
        window.AP.flag.create({
          title: 'Success!',
          body: 'Settings saved successfully',
          type: 'success',
          close: 'auto'
        })
      }, response => {
        console.log('fail')
        window.AP.flag.create({
          title: 'Error',
          body: 'There was an error saving your settings',
          type: 'error',
          close: 'auto'
        })
      })
    }
  },
  mounted () {
    this.commentOnAssociatedIssues = this.$auth.user()['comment_on_associated_issues']
    this.sendEmailNotificationToAssignee = this.$auth.user()['send_email_notification_to_assignee']
    this.confluenceSpacesToFilter = this.$auth.user()['confluence_spaces_to_filter']
    this.backupResizeToParentInCaseAuthViewOneFails()
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// ConfigurationView.vue?011e921d